import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class EndpointBuilderService {

  constructor(private configService: AppConfigService) { }

  public getEndpoint(servicePath: string): string {
    const settings = this.configService.settings;
    if (settings.overrides && settings.overrides[servicePath]) {
      return settings.overrides[servicePath] + servicePath;
    }
    return settings.urlApiBase + servicePath;
  }
}